import { Attribute, Cart } from 'shopify-types'

import { storefrontClient } from '..'
import { GlobalRequestOptions } from '../types'
import { GQL_CART_MUTATION_QUERY, GQLCartMutation, mapGQLCartToCart } from './graphql'

type AttributesUpdateResponse = Readonly<{
  cartAttributesUpdate: GQLCartMutation
}>

export const attributesUpdate =
  (options: GlobalRequestOptions) =>
  async (cartId: string, attributes: Attribute[]): Promise<Cart> => {
    const response = await storefrontClient.request<AttributesUpdateResponse>(
      `#graphql
        mutation cartAttributesUpdate($cartId: ID!, $attributes: [AttributeInput!]!, $language: LanguageCode) @inContext(language: $language) {
          cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
            ${GQL_CART_MUTATION_QUERY}
          }
        }
      `,
      {
        variables: {
          cartId,
          attributes,
          language: options.language,
        },
      },
    )

    if (!response.data?.cartAttributesUpdate.cart) {
      throw new Error('Failed to update attributes')
    }

    return mapGQLCartToCart(response.data.cartAttributesUpdate.cart)
  }
